import { createContext, useCallback, useState } from "react";

export const OverlayContext = createContext(null);

export const OverlayContextProvider = ({ children }) => {
  const [overlayOpened, setOverlayOpened] = useState(false);
  const [flyoutOpened, setFlyoutOpened] = useState(false);

  //If one flyout is closing at the same time as another is opening, make sure the opening is registered last:
  const registerFlyoutOpened = useCallback(() => {
    setTimeout(() => setFlyoutOpened(true), 1);
  }, []);
  const registerFlyoutClosed = useCallback(() => {
    setFlyoutOpened(false);
  }, []);

  return (
    <OverlayContext.Provider
      value={{
        overlayOpened,
        setOverlayOpened,
        flyoutOpened,
        registerFlyoutOpened,
        registerFlyoutClosed
      }}
    >
      {children}
    </OverlayContext.Provider>
  );
};
